import { Component, OnInit } from '@angular/core';
import { UsrCred } from "./../../models/usrcred";
import { VproService } from "./../../service/vpro/vpro.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-forgot-pass-new',
  templateUrl: './forgot-pass-new.component.html',
  styleUrls: ['./forgot-pass-new.component.css']
})
export class ForgotPassNewComponent {

  user = new UsrCred();
  dataValue: boolean;
  innerHtml: string;
  constructor(private mailCheckService: VproService, private spinner: NgxSpinnerService,) { }

  ngOnInit() {
    this.user['account_type'] = "patient"
  }

  lookUp() {
    // Shoot a mail to user
    this.spinner.show();
    if (this.user && this.user.email_id) {
      this.user.email_id = this.user.email_id.toLowerCase();
    }
    console.log("THIS USER::", this.user);
    this.mailCheckService.mailUsrpwd(this.user).subscribe(res => {
      this.spinner.hide();
      Swal.fire({
        allowOutsideClick: false,
        position: "top",
        type: "success",
        title:
          "If the Provided email address is valid, instructions to reset the password will be shared",
        //"An email has been sent to your registered Email-id, Please check your mail for Password Reset Link ",
        showConfirmButton: false,
        timer: 5000
      });
    }, error => {
      console.log(error);
      this.spinner.hide();
      let msg = ""
      // SweetAlert
      Swal.fire({
        allowOutsideClick: false,
        position: "top",
        type: "error",
        title:
          error && error.error && error.error.error
            ? error.error.error
            : "Something went wrong. Please try again later.",
        showConfirmButton: false,
        timer: 2100
      });
    });
  }

}
